import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/headline.module.css';

import type { THeadlineProps, THeadlineVariants, TTag } from './types';

const variants: THeadlineVariants = {
  display1: { classNames: ['display1'] },
  display2: { classNames: ['display2'] },
  display3: { classNames: ['display3'] },
  editorial: { classNames: ['editorialHeadline'] },
  div: { classNames: ['h2'] },
  h1: { classNames: ['h1'] },
  h1Semibold: { classNames: ['h1', 'semibold'] },
  h2: { classNames: ['h2'] },
  h3: { classNames: ['h3'] },
  h4: { classNames: ['h4'] },
  h5: { classNames: ['h5'] },
  h5Semibold: { classNames: ['h5', 'semibold'] },
  h6: { classNames: ['h6'] },
  h6Semibold: { classNames: ['h6', 'semibold'] },
  quoteLarge: { classNames: ['editorialHeadline', 'quoteLarge'] },
  quoteSmall: {  classNames: ['editorialHeadline'] },
  quoteLargeWhite: { classNames: ['editorialHeadline', 'quoteLarge'], color: 'light' },
  quoteSmallWhite: { classNames: ['editorialHeadline'], color: 'light' },
};

/**
 * @deprecated Use the appropriate element (h1, p, div, etc.) directly.
 * Utility classes for styling are in `shared/styles/_typography.scss`.
 * 
 * The HTML tag can be retrieved from the "tag" prop — defaults to `h2`
 */
const Headline = <T extends TTag>(
  { content, setInnerHTML = false, styledAs, tag, ...props }: THeadlineProps<T>,
) => {
  const { className, ...restOfProps } = props;

  const args = {
    ...restOfProps,
  };

  const Component = tag || 'h2';
  
  const { classNames = [], color } = variants[styledAs || Component];

  if (setInnerHTML) {
    args.dangerouslySetInnerHTML = { __html: content };
  } else {
    args.children = content;
  }

  return (
    <Component
      {...args}
      className={generateClassName([s.headline, color && s[color], ...classNames, className])}
    />
  );
};

export default Headline;
